import React from 'react';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

interface StarRatingProps {
  rating: number | null;
  onChange: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, onChange }) => {
  return (
    <Rating
      value={rating}
      onChange={(event, newValue) => {
        onChange(newValue as number);
      }}
      precision={1}
      icon={<StarIcon sx={{ fontSize: '17px' }} />}
      emptyIcon={<StarBorderIcon sx={{ fontSize: '17px' }} />}
    />
  );
};

export default StarRating;
